import CookiesJS from 'js-cookie';

/**
 * Obtiene y parsea una cookie de forma segura
 * @param {string} cookieName - Nombre de la cookie a obtener
 * @returns {object|null} - Objeto parseado o null si la cookie no existe
 */
export const getSafeCookie = (cookieName) => {
  try {
    const cookieValue = CookiesJS.get(cookieName);
    if (!cookieValue || cookieValue === 'undefined') {
      return null;
    }
    return JSON.parse(cookieValue);
  } catch (error) {
    console.warn(`Error parsing cookie "${cookieName}":`, error);
    return null;
  }
};

/**
 * Obtiene el ID de lenguaje de forma segura desde las cookies
 * @returns {number|null} - ID de lenguaje o null
 */
export const getIdLanguage = () => {
  try {
    const idLng = CookiesJS.get("idLng");
    if (idLng && idLng !== 'undefined') {
      return JSON.parse(idLng);
    }
    
    const dataUser = getSafeCookie("dataUser");
    return dataUser?.user?.idLanguage || null;
  } catch (error) {
    console.warn('Error getting idLanguage:', error);
    return null;
  }
};
